'use client'

import { OfficialTickerDetail } from 'components/game/OfficialTickerDetail'
import { useCombinedGameData } from 'components/game/useGameData'
import { ComponentType } from 'react'
import { Game, GameEvent, GameLineup } from 'types'

interface Props {
  game: Game
  events: GameEvent[] | null
  lineup: GameLineup | null
  preferLiveticker: boolean
}

const RefreshedOfficialTicker: ComponentType<Props> = ({
  game,
  events,
  lineup,
  preferLiveticker
}: Props) => {
  const refreshedGameData = useCombinedGameData(game.id)

  return (
    <OfficialTickerDetail
      game={refreshedGameData.game || game}
      events={refreshedGameData.events || events}
      lineup={refreshedGameData.lineup || lineup}
      preferLiveticker={preferLiveticker}
    />
  )
}

export default RefreshedOfficialTicker
